import { mdiClose, mdiFileEditOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import { Col, Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap';
import './ModifyBooking.scss';
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { modifyCancelBooking } from '../../../store/apis/travelService';

function ModifyBooking({ isOpen, toggle, reqNo, revisionNo }) {
  const navigate = useNavigate();
  const {
    control,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      revisionRemarks: '',
    },
    mode: 'onChange',
  });

  const { mutate: cancelTravelMutate } = useMutation({
    mutationFn: payload => modifyCancelBooking(payload),
    onSuccess: response => {
      if (response?.flag === 'True') {
        toast.success('Travel request modified successfully.', {
          className: 'toast-success',
        });
        toggle();
        navigate('/travel-request');
      } else if (response?.flag === 'False') {
        if (response?.errorData && response?.errorData.length > 0) {
          response.errorData.forEach(error => {
            toast.error(error[0]['Error Message'], {
              className: 'toast-error',
            });
          });
        } else {
          toast.error(response?.message || 'Failed to modify travel request.', {
            className: 'toast-error',
          });
        }
      }
    },
    onError: error => {
      toast.error(
        error?.message || 'An error occurred while mopdifying the request.',
        {
          className: 'toast-error',
        },
      );
    },
  });

  const handleModifyTravelRequest = async () => {
    const { revisionRemarks } = getValues();
    if (!revisionRemarks) {
      toast.error('Please provide a reason for modifying travel request.', {
        className: 'toast-error',
      });
    } else {
      const payload = {
        reqNo,
        revisionNo: parseInt(revisionNo, 10),
        revisionRemarks,
        bookingCategory: 'Rebooking',
      };

      cancelTravelMutate(payload);
    }
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <ModalBody>
        <div className="d-flex flex-row align-items-center justify-content-between mb-3">
          <div className="tr-modify-icon">
            <Icon path={mdiFileEditOutline} size={0.7} />
          </div>
          <div>
            <button type="button" className="btn btn-link p-0" onClick={toggle}>
              <Icon path={mdiClose} size={1} />
            </button>
          </div>
        </div>
        <div>
          <h5>Modify Booking</h5>
          <p>Are you sure you want to modify this booking?</p>
        </div>
        <Label>
          Reason<span className="text-danger">*</span>
        </Label>
        <Controller
          control={control}
          name="revisionRemarks"
          render={({ field }) => (
            <Input
              {...field}
              placeholder="Enter"
              type="textarea"
              rows="4"
              className="form-control external-filter-input"
            />
          )}
        />
        {errors.revisionRemarks && (
          <span className="text-danger">
            {errors.revisionRemarks.message || 'Reason is required.'}
          </span>
        )}
      </ModalBody>
      <ModalFooter>
        <Col>
          <button
            type="button"
            onClick={toggle}
            className="tr-cancel-btn w-100"
          >
            No
          </button>
        </Col>
        <Col>
          <button
            type="button"
            className="tr-confirm-btn w-100"
            onClick={handleModifyTravelRequest}
          >
            Yes, Modify
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default ModifyBooking;
